import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from '../../admin/admin.service';
import { DuplikitMergeService } from '../../shared/services/duplikit-merge.service';
import { DuplikitSyncService } from '../../shared/services/duplikit-sync.service';
import { DryRunWarningComponent } from '../dry-run-warning/dry-run-warning.component';
import { SyncComponent } from './sync/sync.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    DryRunWarningComponent,
    SyncComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  constructor(
    private duplikitMergeService: DuplikitMergeService,
    private duplikitSyncService: DuplikitSyncService,
    private adminService: AdminService
  ) {
  }

  ngOnInit() {
    if (!this.adminService.isInLiteMode()) {
      this.duplikitMergeService.runMergeCheck();
      this.duplikitSyncService.runSyncCheck();
    }
  }

  ngOnDestroy() {
    this.duplikitMergeService.stopMergeCheck();
    this.duplikitSyncService.stopSyncCheck();
  }

}
